import type { FaireProductEntity } from "../../entity_types/product";

export const p_x8y4ccgbqk: FaireProductEntity = {
  token: "p_x8y4ccgbqk",
  type: "product",
  name: "Cowboy Crunch Gourmet Popcorn",
  brandToken: "b_pffy5dqdsz",
  brandName: "Bombshell Sweets",
  imageUrl: "https://cdn.faire.com/fastly/55dced148704592ce6cf1f21d119464ffa823f83d6ca688ecbbeaafa3c1c9b73.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/476b88b17588431b1a572236673a2db73e5e47ed0a942dcc0c948bd32d49a485.jpeg",
    "https://cdn.faire.com/fastly/a3cf480d8e414dd5afbf3e8f18ea9c141b27268aac71c395f11cd7dd3f8d7a0a.jpeg",
    "https://cdn.faire.com/fastly/bf0b9262fa3f7dbc60dac1c10f27d0e5438237fbf7b90fcdbea7db8ba45e700b.png"
  ],
  priceDollars: 5.2,
  description: "Saddle up for sweet and smoky flavor. Cowboy Crunch combines the irresistible sweetness of candied bacon with a subtle spicy kick for a bold, frontier-inspired snack. The warm light brown kernels echo the campfire flavors, making this the perfect choice for customers who want something hearty, rugged, and unforgettable.",
  tags: [],
  msrpDollars: 9.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:43.793Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
